import React from "react";

export default function KonBanegaCrorepati() {
    return (

        <div className="modal-dialog modal-xl">
            <div className="modal-content">
                <div className="modal-header">
                    <div className="modal-title h4">Result</div>
                    <button type="button" className="btn-close" aria-label="Close" />
                </div>
                <div className="modal-body">
                    <div className="casino-result-modal">
                        <div className="casino-result-round-id">
                            <span>
                                <b>Round Id: </b> 144250517124410
                            </span>
                            <span>
                                <b>Match Time: </b>17/05/2025 12:44:10
                            </span>
                        </div>
                        <div className="row mt-2">
                            <div className="col-md-12 text-center">
                                <div className="casino-result-cards">
                                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/7HH.jpg" />
                                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/7DD.jpg" />
                                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/3HH.jpg" />
                                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/4SS.jpg" />
                                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/4DD.jpg" />
                                </div>
                            </div>
                        </div>
                        <div className="row mt-2 justify-content-center">
                            <div className="col-md-6">
                                <div className="casino-result-desc">
                                    <div className="casino-result-desc-item">
                                        <div>[Q1] Red-Black</div>
                                        <div>Red</div>
                                    </div>
                                    <div className="casino-result-desc-item">
                                        <div>[Q2] Odd-Even</div>
                                        <div>Odd</div>
                                    </div>
                                    <div className="casino-result-desc-item">
                                        <div>[Q3] 7 Up-7 Down</div>
                                        <div>Down</div>
                                    </div>
                                    <div className="casino-result-desc-item">
                                        <div>[Q4] 3 Card Judgement</div>
                                        <div>4 5 6</div>
                                    </div>
                                    <div className="casino-result-desc-item">
                                        <div>[Q5] Suits</div>
                                        <div>Diamond</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}
